module.exports = __webpack_public_path__ + "media/images/close-0cfd6489536ec0987466795401497368.png";